module.exports = __webpack_public_path__ + "static/img/sysShow3.a26a0325.png";